import BaseApi from "./BaseApi";

export default class StatsBatchApi extends BaseApi {
  static runStatsBatch = () => this.post("statsbatch");
}
